// extracted by mini-css-extract-plugin
export var actionIcon = "_uz-0";